const allGames = [
    {
        title: "Batman Arkham Knight",
        cover: "images/Batman-Arkham-Knight.jpg",
        platform: "PS4",
        completed: false,
        played: true,
        reviewAvailable: false,
        about: "Batman: Arkham Knight is the final instalment for the Arkham series by now. Joining forces with Bruce Wayne for the last time, we have to oppose Scarecrow and other iconic villains such as The Riddler, Harleen Quinzel a.k.a. Harley Quinn, Penguin and others. The story continued after events in Arkham City when Joker died due to infection in his blood. Now, Scarecrow tries to release a new fear toxin, meanwhile new mysterious Arkham Knight plots against Batman as well. Still having consequences after being poisoned by the Joker and seeing visions with him, Bruce has to prevail the death of Gotham City.",
        releaseDate: "Jun 23, 2015"
    },
    {
        title: "Call Of Duty Black Ops 6",
        cover: "images/Call-Of-Duty-Black-Ops-6.jpg",
        platform: "PS5",
        completed: false,
        played: true,
        reviewAvailable: false,
        about: "Initial Intel: Campaign: The Black Ops 6 Campaign takes players to a new point in time – the early 1990s. In true Black Ops fashion, the fictional story builds on the history of the time, thrusting you into a strange and clandestine conspiracy where a shadowy force has infiltrated the U.S. government. Anyone who resists is branded as a traitor, forcing players to go rogue for the first time to fight the very machine that created them. Nothing is what it seems, and the truth may be hard to fathom, drawing you ever deeper into intrigue, distrust, and mind-bending psychological revelations. This is true, signature Black Ops style.",
        releaseDate: "Oct 24, 2024"
    },
    {
        title: "Crash Bandicoot 4 It's About Time",
        cover: "images/Crash-Bandicoot-4-Its-About-Time.jpg",
        platform: "PS5",
        completed: true,
        played: true,
        reviewAvailable: false,
        about: "Neo Cortex and N. Tropy are back at it again and launching an all-out assault on not just this universe, but the entire multiverse! Crash and Coco are here to save the day by reuniting the Four Quantum masks and bending the rules of reality. New abilities? Check. More playable characters? Yep. Alternate dimensions? Obviously. Ridonkulous bosses? For sure. Same awesome sauce? You bet your sweet jorts. Wait, are they actually jorts? Not in this universe!",
        releaseDate: "Oct 1, 2020"
    },
    {
        title: "Crash Bandicoot N.Sane Trilogy",
        cover: "images/Crash-Bandicoot-NSane-Trilogy.jpg",
        platform: "PS5",
        completed: true,
        played: true,
        reviewAvailable: false,
        about: "Your favorite marsupial, Crash Bandicoot™, is back! He’s enhanced, entranced and ready-to-dance with the N. Sane Trilogy game collection. Now you can experience Crash Bandicoot like never before. Spin, jump, wump and repeat as you take on the epic challenges and adventures through the three games that started it all, Crash Bandicoot™, Crash Bandicoot™ 2: Cortex Strikes Back and Crash Bandicoot™ 3: Warped. Relive all your favorite Crash moments in their fully-remastered graphical glory and get ready to put some UMPH in your WUMP!Crash Bandicoot™ N.",
        releaseDate: "Jun 30, 2017"
    },
    {
        title: "Demon's Souls",
        cover: "images/Demon-Souls.jpg",
        platform: "PS5",
        completed: true,
        played: true,
        reviewAvailable: false,
        about: "From PlayStation Studios and Bluepoint Games comes a remake of the PlayStation classic, Demon’s Souls. Entirely rebuilt from the ground up and masterfully enhanced, this remake introduces the horrors of a fog-laden, dark fantasy land to a whole new generation of gamers. Those who’ve faced its trials and tribulations before, can once again challenge the darkness in stunning visual quality and incredible performance.",
        releaseDate: "Nov 12, 2020"
    },
    {
        title: "Fall Guys",
        cover: "images/Fall-Guys.jpg",
        platform: "PS5",
        completed: false,
        played: true,
        reviewAvailable: false,
        about: "",
        releaseDate: ""
    },
    {
        title: "Pokemon Brilliant Diamond",
        cover: "images/Pokemon-Brilliant-Diamond.jpg",
        platform: "Nintendo Switch",
        completed: false,
        played: true,
        reviewAvailable: false,
        about: "The Sinnoh Region of the Pokémon Brilliant Diamond and Pokémon Shining Pearl Games. Experience the nostalgic story from the Pokémon Diamond™ and Pokémon Pearl™ games in an adventure reborn on the Nintendo Switch™ system. Adventures in the Pokémon Brilliant Diamond and Pokémon Shining Pearl games will take place in the Sinnoh region. Rich in nature and with Mount Coronet towering at its heart, Sinnoh is a land of many myths passed down through the ages. You’ll visit many different locations in the Sinnoh region, while striving to become the Champion of the Pokémon League.",
        releaseDate: "Nov 19, 2021"
    },
    {
        title: "South Park Fractured But Whole",
        cover: "images/South-Park-Fractured-But-Whole.jpg",
        platform: "PS4",
        completed: false,
        played: true,
        reviewAvailable: false,
        about: "The second part in a series of jRPG-like games in the popular cartoon universe about the of schoolchildren adventures. South Park already had attempted to make quality games, but until recently they were unsuccessful. In this case, the stars converged and the game, like its predecessor, proved to be successful.",
        releaseDate: "Mar 31, 2017"
    },
    {
        title: "The Last Of Us",
        cover: "images/The-Last-Of-Us.jpg",
        platform: "PS4",
        completed: false,
        played: true,
        reviewAvailable: false,
        about: "The population of the Earth almost disappeared as a result of a pandemic caused by a mutated fungus. The disease causes irreversible changes in the human body, a person loses his mind and behaves aggressively, like a zombie. Civilization no longer exists, few survivors live in isolation under the protection of the military.",
        releaseDate: "Jun 14, 2013"
    },
]

export default allGames